import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import * as getters from './getters';
import * as actionsG from './actions';
import * as actionsAxios from './actions-axios';
import * as actionsAxiosZi from './actions-axios_zi';
import * as actionsAxiosLu from './actions-axios_lu';
import * as actionsAxiosYl from './actions-axios_ly';
import * as modules from './modules';

import {
	getters as irstoreGetters,
	mutations as irstoreMutations,
	actions as irstoreActions
} from '@/store/modules/irstore';

const actions = Object.assign(actionsG, actionsAxios, actionsAxiosZi, actionsAxiosLu, actionsAxiosYl);

Vue.use(Vuex);
// const debug = process.env.NODE_ENV !== 'production'

const Store = new Vuex.Store({
	state,
	mutations: {
		...mutations,
		...irstoreMutations
	},
	getters: {
		...getters,
		...irstoreGetters
	},
	actions: {
		...actions,
		...irstoreActions
	},
	modules: { ...modules },

	strict: false
});

export default Store;
